import * as React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ScreenMode } from "../../../models/enums";
import { ILocalization } from "../../../models/localization";
import OpportunityStore from "../../../stores/opportunityStore";
import { SavedOpportunity } from "../../../models/profile";
import { Opportunity, OpportunitySummary } from "../../../models/opportunity";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./tabs.css";

interface IParams {
  opId: string;
}
export class LocationTab extends React.Component<{ store: SeekerStore, params: IParams }, {}>{
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col sm={4} className={s.tabSubContainer}>
      <div className={s.tab1}>
        <img className={s.tabIcon} src={local.icons.distance} />
        <p className={s.tabText}>{this._opStore.selectedOp.location}</p>
      </div></Col>)
  }
}

export class TypeTab extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;   
    //this._opStore.selectOpportunity(this.props.params.opId);
    return (<Col sm={4} className={s.tabSubContainer}>
      <div className={s.tab2}>
        <img className={s.tabIcon} src={local.icons.duration} />
        <p className={s.tabText}>{this._opStore.selectedOp.positionType}</p>
      </div></Col>)
  }
}

export class ExpLevelTab extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col sm={4} className={s.tabSubContainer}>
      <div className={s.tab3}>
        <img className={s.tabIcon} src={local.icons.layers} />
      <p className={s.tabText}>{local.addJob.expLevel[this._opStore.selectedOp.expLevel]}</p>
      </div></Col >)
  }
}

export class SalaryTab extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col sm={4} className={s.tabSubContainer}>
      <div className={s.tab3}>
        <img className={s.tabIcon} src={local.icons.salary} />
        <p className={s.salaryText}>${this._opStore.selectedOp.salaryFrom} {this._opStore.selectedOp.salaryTo ? `- $${this._opStore.selectedOp.salaryTo}` : local.opportunity.hourly}</p>
      </div></Col >)
  }
}

export class TabsHorizontal extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }
  render(): JSX.Element {
    return (<Col sm={12} className={s.tabContainer}>
      <LocationTab store={this.props.store} params={this.props.params} />
      <TypeTab store={this.props.store} params={this.props.params} />
      {this._opStore.selectedOp.salaryFrom > 0 && <SalaryTab store={this.props.store} params={this.props.params} />}
      {this._opStore.selectedOp.salaryFrom === 0 && <ExpLevelTab store={this.props.store} params={this.props.params} />}
    </Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/tabsHorizontal/index.tsx